<ng-container *ngIf="form.get(fieldName) || fieldControl as f; else errore">
  <label *ngIf="fieldLabel" [for]="fieldName" class="form-label">{{ fieldLabel }}</label>

  <select
    *ngIf="!readonlyField; else readonlySelect"
    class="form-select"
    [class.is-invalid]="f.errors"
    [class.is-warned]="!!warnings"
    [formControl]="f | toFormControl"
    [id]="fieldName"
  >
    <option value="">{{ selectedString }}</option>
    <option *ngFor="let item of items" [ngValue]="item.value" [disabled]="item.isDisabled">
      {{ item.key }}
    </option>
  </select>

  <ng-template #readonlySelect>
    <select disabled class="form-select" [id]="fieldName">
      <option value="">Campo non compilato</option>
      <option *ngFor="let item of items" [value]="item.value" [selected]="item.value === f.value">
        {{ item.key }}
      </option>
    </select>
  </ng-template>

  <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>
  <field-warnings [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>
</ng-container>

<ng-template #errore>
  Il campo <i>{{ fieldName }}</i> non esiste
</ng-template>
